import React from 'react';
import Icon from '../../../components/AppIcon';

const ComparisonWidget = ({ title, currentPeriod, previousPeriod, metrics = [] }) => {
  const defaultMetrics = [
    {
      label: 'إجمالي العقارات',
      current: '٢٤٥',
      previous: '٢١٨',
      change: '+١٢.٤٪',
      changeType: 'positive'
    },
    {
      label: 'العملاء الجدد',
      current: '٨٩',
      previous: '١٠٢',
      change: '-١٢.٧٪',
      changeType: 'negative'
    },
    {
      label: 'العقود المكتملة',
      current: '٥٦',
      previous: '٤٨',
      change: '+١٦.٧٪',
      changeType: 'positive'
    },
    {
      label: 'الإيرادات (د.إ)',
      current: '٣٤٥,٠٠٠',
      previous: '٣١٢,٠٠٠',
      change: '+١٠.٦٪',
      changeType: 'positive'
    }
  ];

  const metricsList = metrics?.length > 0 ? metrics : defaultMetrics;

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 shadow-warm">
      <div className="mb-4">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-2">{title}</h3>
        <div className="flex items-center gap-4 text-sm text-muted-foreground">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-primary"></div>
            <span>{currentPeriod}</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-muted"></div>
            <span>{previousPeriod}</span>
          </div>
        </div>
      </div>
      <div className="space-y-4">
        {metricsList?.map((metric, index) => (
          <div key={index} className="pb-4 border-b border-border last:border-0 last:pb-0">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-muted-foreground">{metric?.label}</span>
              <div className={`flex items-center gap-1 text-sm font-medium ${
                metric?.changeType === 'positive' ? 'text-success' : 'text-error'
              }`}>
                <Icon 
                  name={metric?.changeType === 'positive' ? 'TrendingUp' : 'TrendingDown'} 
                  size={14} 
                />
                <span className="font-data">{metric?.change}</span>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="flex-1">
                <div className="text-xl font-heading font-bold text-foreground font-data">
                  {metric?.current}
                </div>
                <div className="text-xs text-muted-foreground mt-1">الفترة الحالية</div>
              </div>
              <div className="flex-1">
                <div className="text-lg font-heading font-semibold text-muted-foreground font-data">
                  {metric?.previous}
                </div>
                <div className="text-xs text-muted-foreground mt-1">الفترة السابقة</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ComparisonWidget;